module.exports = __webpack_public_path__ + "img/gashplus.2cad8c98.png";